import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import { Container, Row, Col, Spinner, Card } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import AppNavbar from "../../components/AppNavbar";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa";

const BlogDetailPage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlog = async () => {
    try {
      const res = await api.get(`/blogs/${id}`);
      setBlog(res.data);
    } catch (err) {
      console.error("Blog alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlog();
  }, [id]);

  if (loading)
    return (
      <>
        <AppNavbar />
        <Container className="text-center mt-5 pt-5">
          <Spinner animation="border" />
        </Container>
      </>
    );

  if (!blog)
    return (
      <>
        <AppNavbar />
        <Container className="text-center mt-5 pt-5">
          <h4>Blog bulunamadı.</h4>
        </Container>
      </>
    );

  return (
    <>
      <AppNavbar />

      {/* HERO IMAGE */}
      <div
        style={{
          marginTop: "70px",
          height: "350px",
          width: "100%",
          backgroundImage: `url(${blog.imageUrl || "/default-blog.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderBottomLeftRadius: "40px",
          borderBottomRightRadius: "40px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
        }}
      ></div>

      <Container style={{ maxWidth: "1050px" }} className="mt-5">
        <Row className="g-4">
          {/* SAĞ SİDEBAR */}
          <Col lg={4} className="order-lg-2">
            {/* GERİ DÖN */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="p-4 rounded-4 shadow-sm bg-white sticky-top"
              style={{ top: "100px" }}
            >
              <Link
                to="/blogs"
                className="btn btn-outline-primary rounded-pill mb-3 w-100"
              >
                <FaArrowLeft className="me-2" /> Tüm Bloglara Dön
              </Link>

              <p className="text-muted small mb-1">Yayın Tarihi</p>
              <h6 className="fw-semibold">
                {new Date(blog.createdAt).toLocaleDateString("tr-TR")}
              </h6>

              {/* Reklam Alanı */}
              <Card
                className="p-4 shadow-sm rounded-4 text-center mt-4"
                style={{
                  background: "#f8fafc",
                  border: "2px dashed #cdd6dd",
                }}
              >
                <h6 className="fw-bold mb-2">Reklam Alanı</h6>
                <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                  Bu alana reklam verebilirsiniz.  
                  <br />  
                  info@majistralapp.com
                </p>
              </Card>
            </motion.div>
          </Col>

          {/* SOL TARAF – BLOG İÇERİK */}
          <Col lg={8} className="order-lg-1">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h1
                className="fw-bold mb-3"
                style={{ color: "#2D8A7A", lineHeight: "1.3" }}
              >
                {blog.title}
              </h1>

              <Card className="p-4 shadow-sm rounded-4 mb-4">
                <div
                  className="blog-content"
                  style={{
                    fontSize: "1.1rem",
                    lineHeight: "1.8",
                    color: "#444",
                  }}
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .blog-content h2, .blog-content h3 {
          color: #2D8A7A;
          margin-top: 25px;
          font-weight: 600;
        }

        .blog-content p {
          margin-bottom: 18px;
        }

        .hover-scale:hover {
          transform: scale(1.02);
          transition: 0.3s;
        }
      `}</style>
    </>
  );
};

export default BlogDetailPage;
